import { render, staticRenderFns } from "./aufgaben-verlauf.vue?vue&type=template&id=5d0e88c4&scoped=true"
import script from "./aufgaben-verlauf.vue?vue&type=script&lang=js"
export * from "./aufgaben-verlauf.vue?vue&type=script&lang=js"
import style0 from "./aufgaben-verlauf.vue?vue&type=style&index=0&id=5d0e88c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0e88c4",
  null
  
)

export default component.exports